import { ApiConfig } from 'src/plugins/api/declare'

const apiConfig: ApiConfig[] = [
  {
    name: 'getServerStatusInfo',
    method: 'POST',
    path: '/OP/OPServerConf/GetServerStatusInfo',
    params: {},
    axiosOptions: {},
    desc: 'IT运维列表'
  },
]

export default apiConfig